import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ContactSupport = () => {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const emailAddress = 'support@smrtpdftools.com';

  const copyToClipboard = () => {
    // Try modern clipboard API first
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(emailAddress)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 3000);
        })
        .catch(() => fallbackCopy());
    } else {
      fallbackCopy();
    }
  };

  const fallbackCopy = () => {
    const textArea = document.createElement('textarea');
    textArea.value = emailAddress;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      alert('Please manually copy: ' + emailAddress);
    }
    document.body.removeChild(textArea);
  };

  const EmailSection = ({ title, icon, description }) => (
    <div style={{ 
      background: '#ffffff', 
      padding: '30px', 
      borderRadius: '12px', 
      border: '2px solid #e5e7eb',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    }}>
      <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', color: '#1f2937', display: 'flex', alignItems: 'center' }}>
        <span style={{ marginRight: '12px', fontSize: '1.8rem' }}>{icon}</span> {title}
      </h3>
      <p style={{ margin: '15px 0', color: '#6b7280', lineHeight: '1.6' }}>{description}</p>
      
      {/* Email Display Box */}
      <div style={{
        background: '#f9fafb',
        border: '2px dashed #cbd5e1',
        borderRadius: '8px',
        padding: '15px',
        margin: '20px 0',
        textAlign: 'center'
      }}>
        <p style={{ fontSize: '0.85rem', color: '#6b7280', marginBottom: '8px', fontWeight: '500' }}>
          EMAIL ADDRESS
        </p>
        <p style={{
          fontSize: '1.2rem',
          fontWeight: '700',
          color: '#2563eb',
          fontFamily: 'monospace',
          letterSpacing: '0.5px',
          userSelect: 'all',
          cursor: 'text',
          padding: '8px',
          background: '#fff',
          borderRadius: '6px',
          margin: '10px 0'
        }}>
          {emailAddress}
        </p>
        <p style={{ fontSize: '0.75rem', color: '#9ca3af', marginTop: '5px' }}>
          👆 You can also select and copy this text manually
        </p>
      </div>

      {/* Large Copy Button */}
      <button 
        onClick={copyToClipboard}
        style={{ 
          width: '100%',
          padding: '16px 24px', 
          background: copied ? '#10b981' : '#2563eb',
          color: 'white', 
          border: 'none', 
          borderRadius: '10px', 
          cursor: 'pointer',
          fontSize: '1.1rem',
          fontWeight: '700',
          transition: 'all 0.3s',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px'
        }}
        onMouseOver={(e) => {
          if (!copied) {
            e.target.style.background = '#1d4ed8';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 8px rgba(0,0,0,0.15)';
          }
        }}
        onMouseOut={(e) => {
          if (!copied) {
            e.target.style.background = '#2563eb';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
          }
        }}
      >
        <span style={{ fontSize: '1.5rem' }}>{copied ? '✅' : '📋'}</span>
        <span>{copied ? 'EMAIL COPIED TO CLIPBOARD!' : 'CLICK HERE TO COPY EMAIL'}</span>
      </button>
      
      {copied && (
        <p style={{ 
          textAlign: 'center', 
          color: '#10b981', 
          fontWeight: '600', 
          marginTop: '12px',
          fontSize: '0.95rem'
        }}>
          ✓ Now paste it into your email client!
        </p>
      )}
    </div>
  );

  return (
    <div style={{ 
      maxWidth: '900px', 
      margin: '0 auto', 
      padding: '40px 20px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      lineHeight: '1.6',
      color: '#333',
      background: '#fafafa',
      minHeight: '100vh'
    }}>
      {/* Back to Home Button */}
      <button
        onClick={() => navigate('/')}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          background: '#2563eb',
          color: 'white',
          border: 'none',
          padding: '10px 20px',
          borderRadius: '8px',
          fontSize: '0.95rem',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.2s',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          marginBottom: '30px'
        }}
        onMouseOver={(e) => e.target.style.background = '#1d4ed8'}
        onMouseOut={(e) => e.target.style.background = '#2563eb'}
      >
        <span>←</span> Back to Home
      </button>
      
      <div style={{ textAlign: 'center', marginBottom: '50px' }}>
        <h1 style={{ fontSize: '3rem', marginBottom: '15px', color: '#1f2937', fontWeight: '800' }}>
          Contact & Support
        </h1>
        <p style={{ color: '#6b7280', fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto' }}>
          We're here to help! Reach out to us for any questions, issues, or feedback.
        </p>
      </div>

      <div style={{ display: 'grid', gap: '30px' }}>
        <EmailSection 
          icon="📧" 
          title="General Support" 
          description="For general questions, technical support, or account assistance. Response time: Within 24-48 hours."
        />
        
        <EmailSection 
          icon="⚖️" 
          title="Legal & Compliance" 
          description="For legal inquiries, DMCA notices, or compliance matters."
        />
        
        <EmailSection 
          icon="🚨" 
          title="Report Abuse" 
          description="To report violations of our Acceptable Use Policy or Terms of Service. We take abuse reports seriously and investigate promptly."
        />
        
        <EmailSection 
          icon="💳" 
          title="Billing & Subscriptions" 
          description="For billing questions, refund requests, or subscription management. Please include your account email and transaction details."
        />
        
        <EmailSection 
          icon="🤝" 
          title="Business & Partnerships" 
          description="For business inquiries, partnerships, or enterprise solutions."
        />
      </div>

      {/* Office Address */}
      <section style={{ marginTop: '60px', marginBottom: '40px' }}>
        <h2 style={{ fontSize: '2rem', marginBottom: '20px', color: '#2563eb', textAlign: 'center' }}>Office Address</h2>
        <div style={{ background: '#ffffff', padding: '30px', borderRadius: '12px', border: '2px solid #e5e7eb', textAlign: 'center' }}>
          <p style={{ margin: '8px 0', fontSize: '1.1rem', fontWeight: '600' }}>SmartPDF Tools, Inc.</p>
          <p style={{ margin: '8px 0', color: '#6b7280' }}>123 PDF Street, Suite 100</p>
          <p style={{ margin: '8px 0', color: '#6b7280' }}>San Francisco, CA 94102</p>
          <p style={{ margin: '8px 0', color: '#6b7280' }}>United States</p>
        </div>
      </section>

      {/* Business Hours */}
      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '2rem', marginBottom: '20px', color: '#2563eb', textAlign: 'center' }}>Business Hours</h2>
        <div style={{ background: '#ffffff', padding: '25px', borderRadius: '12px', border: '2px solid #e5e7eb' }}>
          <p style={{ color: '#6b7280', marginBottom: '15px', textAlign: 'center' }}>Our support team operates during the following hours (PST):</p>
          <div style={{ maxWidth: '400px', margin: '0 auto' }}>
            <p style={{ margin: '8px 0', display: 'flex', justifyContent: 'space-between' }}>
              <strong>Monday - Friday:</strong> <span>9:00 AM - 6:00 PM PST</span>
            </p>
            <p style={{ margin: '8px 0', display: 'flex', justifyContent: 'space-between' }}>
              <strong>Saturday:</strong> <span>10:00 AM - 4:00 PM PST</span>
            </p>
            <p style={{ margin: '8px 0', display: 'flex', justifyContent: 'space-between' }}>
              <strong>Sunday:</strong> <span>Closed</span>
            </p>
          </div>
          <p style={{ color: '#9ca3af', fontSize: '0.9rem', marginTop: '15px', textAlign: 'center' }}>
            Emails received outside business hours will be responded to on the next business day.
          </p>
        </div>
      </section>

      {/* Quick Tip */}
      <div style={{ 
        marginTop: '40px', 
        padding: '25px', 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
        borderRadius: '12px',
        color: 'white',
        textAlign: 'center'
      }}>
        <h3 style={{ fontSize: '1.5rem', marginBottom: '12px', fontWeight: '700' }}>💡 Quick Tip</h3>
        <p style={{ margin: 0, fontSize: '1.05rem', lineHeight: '1.6' }}>
          For the fastest response, make sure to include your account email and a detailed description of your issue or question!
        </p>
      </div>
    </div>
  );
};

export default ContactSupport;
